var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2255 5.30674L11.0112 10.4754L6.54785 8.21683L16.7624 3.04816L21.2255 5.30674Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.785645 5.20748L10.6485 0.216399C10.8695 0.104543 11.1304 0.104543 11.3514 0.216399L14.994 2.05963L4.77943 7.2283L0.785645 5.20748Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2143 22L0.434238 17.0513C0.168143 16.9161 0 16.6413 0 16.3399V6.49396L10.2143 11.6626V22Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 6.49396V16.3399C21.9999 16.6413 21.8318 16.9161 21.5657 17.0513L11.7856 22V11.6626L21.9999 6.49396Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingPackage);
export default __webpack_public_path__ + "static/media/shipping-package.f9d86933a09dd6206c93a46a65217b07.svg";
export { ForwardRef as ReactComponent };